import InitialState from '@/InitialState';
import { webPushCapability } from '@/Components/PushNotification/PushUtility';
import { iOSPushCapability } from '@/Components/PushNotification/IosPushBridgeUtility';

export default {
    pushCapability: InitialState.featureFlags.pushNotificationsEnabled && (iOSPushCapability() || webPushCapability()),
};